import { useEffect, useState } from "react";
import { Building2, MapPin, Mail } from "lucide-react";

import api from "../../lib/api";
import { Loading } from "../../components/shared";

export default function ResidentMySociety() {
  const [societies, setSocieties] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    Promise.all([api.get("/resident/societies"), api.get("/resident/society")]).then(([list, current]) => {
      setSocieties(list.data);
      setDetail(current.data);
    });
  }, []);

  if (!societies) return <Loading />;

  return (
    <div data-testid="resident-my-society-page">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">My Society</p>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900">Your societies</h1>
      {detail && <section className="mt-6 border border-slate-200 bg-white p-5" data-testid="resident-society-detail">
        {detail.society.logo_data_url && <img alt="Society logo" className="h-12 w-12 object-contain" data-testid="resident-society-logo" src={detail.society.logo_data_url} />}
        <h2 className="mt-3 font-display text-xl font-semibold">{detail.society.name}</h2>
        {detail.society.registration_number && <p className="mt-1 text-sm text-slate-600">Registration: {detail.society.registration_number}</p>}
        {detail.committee.length ? <div className="mt-5"><h3 className="font-semibold text-slate-900">Current committee</h3><div className="mt-2 flex flex-wrap gap-2">{detail.committee.map((member, index) => <span className="border border-slate-200 bg-slate-50 px-3 py-2 text-sm" data-testid={`resident-committee-${index}`} key={`${member.name}-${index}`}>{member.name} · {member.position}</span>)}</div></div> : <p className="mt-5 text-sm text-slate-600" data-testid="resident-committee-empty">No committee contacts are published.</p>}
      </section>}
      <div className="mt-8 grid gap-4 lg:grid-cols-2">
        {societies.map((society) => (
          <article
            className="border border-slate-200 bg-white p-5"
            data-testid={`resident-society-${society.society_id}`}
            key={society.society_id}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <Building2 className="h-5 w-5 text-primary" />
                <h2 className="mt-4 font-display text-xl font-semibold text-slate-900">
                  {society.name}
                </h2>
              </div>
              {society.active && (
                <span className="border border-emerald-200 bg-emerald-50 px-2 py-1 text-xs text-emerald-800">
                  Active context
                </span>
              )}
            </div>
            {(society.address || society.city) && (
              <p className="mt-5 flex items-center gap-2 text-sm text-slate-600">
                <MapPin className="h-4 w-4" />
                {[society.address, society.city].filter(Boolean).join(", ")}
              </p>
            )}
            {society.official_email && (
              <p className="mt-2 flex items-center gap-2 text-sm text-slate-600">
                <Mail className="h-4 w-4" />
                {society.official_email}
              </p>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}